import { render, staticRenderFns } from "./GeneralAlerts.vue?vue&type=template&id=52891ff7"
import script from "./GeneralAlerts.vue?vue&type=script&lang=ts"
export * from "./GeneralAlerts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports